<template>
  <div class="page-content">
    <div class="page-header">
      <owner-info ref="ownerInfo" :info="info" class="owner-info"></owner-info>
      <fee-info ref="feeInfo" :info="info" class="fee-info"></fee-info>
    </div>
    <div class="page-center">
      <payment-status ref="paymentStatus" :info="info" class="payment-status"></payment-status>
    </div>
    <div class="page-bottom">
      <missing-information ref="missingInformation" class="missing-information"></missing-information>
    </div>
  </div>
</template>

<script>
import ownerInfo from './ownerInfo'
import feeInfo from './feeInfo'
import paymentStatus from './paymentStatus'
import missingInformation from './missingInformation'
import api from '@common/api/index.js'
export default {
  name: 'tenant',
  components: {
    ownerInfo,
    feeInfo,
    paymentStatus,
    missingInformation
  },
  data () {
    return {
      info: {}
    }
  },
  created () {
    this.handleGetInfo()
  },
  methods: {
    handleGetInfo () {
      api.tmp.getProprietorInformationOverview().then(res => {
        if (res.success && res.data) {
          this.info = res.data
        }
        else {
          this.info = {}
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  margin: 16px;
  // padding: 16px;
  width: calc(100% - 16px);
  height: calc(100% - 32px);
  // background-color: #fff;
  box-sizing: border-box;
  .page-header {
    width: 100%;
    height: 380px;
    display: flex;
    .owner-info,
    .fee-info {
      width: calc(50% - 8px);
      height: 100%;
      background-color: #fff;
      border: 1px solid #ddd;
      border-radius: 8px;
      margin-right: 16px;
    }
  }
  .page-center {
    margin: 16px 0;
    width: 100%;
    height: 200px;
    padding: 16px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-sizing: border-box;
  }
  .page-bottom {
    margin: 16px 0;
    width: 100%;
    height: 280px;
    padding: 16px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-sizing: border-box;
  }
}
</style>
